// 订单评价页面
export default {
  routes: [
    {
      path: '/order-evaluation',
      name: 'orderEvaluation',
      meta: {
        title: '订单评价',
        pageId: 'Y7806',
        level: 4,
        isAutoPV: false
      },
      component: () =>
        import(/* webpackChunkName: "orderEvaluation" */ '../views/orderEvaluation/index.vue')
    },
    {
      // 这个是用最连接，给出的半屏连接也是最新的，以后统一用这个，不再用/order-evaluation
      path: '/order-evaluation-new',
      name: 'orderEvaluationNew',
      meta: {
        title: '订单评价',
        pageId: 'Y7806',
        level: 4,
        isAutoPV: false
      },
      component: () =>
        import(/* webpackChunkName: "orderEvaluationNew" */ '../views/orderEvaluation/indexNew.vue')
    },
    {
      // 让rd查，这个好像是没有被用过
      path: '/new-order-evaluation',
      name: 'newOrderEvaluation',
      meta: {
        title: '订单评价',
        pageId: 'E5527',
        level: 4,
        isAutoPV: false
      },
      component: () =>
        import(/* webpackChunkName: "newOrderEvaluation" */ '../views/orderEvaluation/indexB.vue')
    }
  ]
}
